import { TableOfContentsIcon } from './TableOfContentsIcon';

/**
 * author: Google
 * id 70A0953D-9FEF-4858-8ACB-A90C5613360A
 * name table-of-contents
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/table-of-contents.svg
 * tags
 */
export const TocIcon = TableOfContentsIcon;
export default TocIcon